module.exports = __webpack_public_path__ + "static/media/web.29f60389.webp";